import React, { useState, useEffect } from 'react';
import { Form, useParams } from 'react-router-dom';
import axios from 'axios';
import { jwtDecode } from 'jwt-decode';
import NavigationUser from '../../Layouts/Navigation/NavigationUser'
import { Container, Typography, Box, Grid, Paper, Table, TableBody, TableCell, 
    TableContainer, TableHead, TableRow, TablePagination, Button, Dialog, DialogActions, 
    DialogContent, DialogContentText, DialogTitle, TextField, Alert, Snackbar,
    FormControl, InputLabel, MenuItem, FormHelperText, Select} from '@mui/material';
import { format, min } from 'date-fns';
import PostAddIcon from '@mui/icons-material/PostAdd';
import { BASE_URL } from '../../utils/constants';
import useAutoDismissSnack from '../../Hooks/AutoDismissSnack';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';


function PackagesControl() {  

    const [paqueteria, setPaqueteria] = useState([]);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);


    const [openDialog, setOpenDialog] = useState(false);
    const [packageInfo, setPackageInfo] = useState(null);
    const [isPackageRegistered, setIsPackageRegistered] = useState(false);
    const [InquilinoId, setInquilinoId] = useState(null);


    //Snack notifications
    const [openSnack, setOpenSnack] = React.useState(false);
    const [snackStatus, setSnackStatus] = useState("");
    const [snackMessage, setSnackMessage] = useState("");
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));

    const getRowColor = (status) => {
    switch (status) {
        case 'Entregado':
            return '#ddffdd';
        case 'Pendiente':
            return '#fff4ec';
        default:
            return 'inherit';
        }
    };

    const handleClickSnack = () => {
        setOpenSnack(true);
    };

    const handleCloseSnack = () => {
        setOpenSnack(false);
    };
    useAutoDismissSnack(openSnack, setOpenSnack);
    
    const handleClose = () => {
        setOpenDialog(false);
    };

    const formatDate = (dateString) => {
        return format(new Date(dateString), 'yyyy-MM-dd hh:mm:ss a');
    };

    const getPaqueteriaByIdInquilino = () => {
        axios.get(`${BASE_URL}/getPaqueteriaByIdInquilino/${InquilinoId}`)
        .then((response) => {
            const paquetesPendientes = response.data.filter(paquete => paquete.estado === 'Pendiente');
            setPaqueteria(paquetesPendientes);
        })
        .catch((error) => {
            console.log(error);
        });
    };
  
    const handleInfoPackage = (paquete) => {
        //console.log(paquete);
        setPackageInfo(paquete); // Actualiza la información del paquete
        setOpenDialog(true); // Abre el diálogo
    };


    // Efecto para obtener el ID del usuario del token (solo se ejecuta una vez al montar)
    useEffect(() => {
        const token = localStorage.getItem('token');
        if (token) {
            const decodedToken = jwtDecode(token);
            setInquilinoId(decodedToken.id_usuario);
        } else {
            console.log('No hay token');
        }
    }, []);

    // Efecto para cargar paquetes cuando InquilinoId esté disponible
    useEffect(() => {
        if (InquilinoId) {
            getPaqueteriaByIdInquilino();
        }
    }, [InquilinoId]);


  return (
    <>
        <NavigationUser/>
        
        <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 p-4 sm:p-6 lg:p-8">
            <div className="max-w-7xl mx-auto">
                {/* Header */}
                <div className="mb-8">
                    <h1 className="text-3xl font-bold text-gray-800 mb-2">Mis Paquetes</h1>
                    <p className="text-gray-600">Paquetes pendientes por recoger en portería</p>
                </div>

                {/* Estadísticas rápidas */}
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
                    <div className="bg-white rounded-xl shadow-md p-6">
                        <div className="flex items-center justify-between">
                            <div>
                                <p className="text-sm text-gray-600 mb-1">Total Pendientes</p>
                                <p className="text-3xl font-bold text-amber-600">{paqueteria.length}</p>
                            </div>
                            <div className="p-3 bg-amber-100 rounded-lg">
                                <span className="text-2xl">📦</span>
                            </div>
                        </div>
                    </div>
                </div>

                <Snackbar open={openSnack} autoHideDuration={5000} onClose={handleCloseSnack}>
                    <Alert 
                    onClose={handleCloseSnack} 
                    severity={snackStatus} 
                    sx={{ width: '100%' }}>
                    {snackMessage}
                    </Alert>
                </Snackbar>

                {/* Tabla de Paquetes Centrada */}
                <div className="max-w-6xl mx-auto px-4">
                    {paqueteria.length === 0 ? (
                        <div className="bg-white rounded-xl shadow-md p-12 text-center">
                            <span className="text-6xl mb-4 block">📦</span>
                            <p className="text-gray-600 text-lg font-semibold">¡Todo recogido!</p>
                            <p className="text-gray-400 mt-2">No tienes paquetes pendientes por recoger</p>
                        </div>
                    ) : (
                        <div className="bg-white rounded-xl shadow-lg overflow-hidden border border-gray-200">
                            <TableContainer component={Paper} sx={{ boxShadow: 'none' }}>
                                <Table sx={{ minWidth: 650 }} stickyHeader>
                                    <TableHead>
                                        <TableRow sx={{ backgroundColor: '#f59e0b' }}>
                                            <TableCell sx={{ fontWeight: 'bold', fontSize: '0.875rem', color: '#ffffff', borderBottom: '2px solid #d97706' }}>Torre</TableCell>
                                            <TableCell sx={{ fontWeight: 'bold', fontSize: '0.875rem', color: '#ffffff', borderBottom: '2px solid #d97706' }}>Apto.</TableCell>
                                            <TableCell sx={{ fontWeight: 'bold', fontSize: '0.875rem', color: '#ffffff', borderBottom: '2px solid #d97706' }}>Nombre</TableCell>
                                            <TableCell sx={{ fontWeight: 'bold', fontSize: '0.875rem', color: '#ffffff', borderBottom: '2px solid #d97706' }}>Fecha ingreso</TableCell>
                                            <TableCell sx={{ fontWeight: 'bold', fontSize: '0.875rem', color: '#ffffff', borderBottom: '2px solid #d97706' }}>Estado</TableCell>
                                            <TableCell sx={{ fontWeight: 'bold', fontSize: '0.875rem', color: '#ffffff', borderBottom: '2px solid #d97706' }}>Información</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {paqueteria.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((paquete) => (
                                            <TableRow
                                                key={paquete.id_paquete}
                                                sx={{ 
                                                    backgroundColor: getRowColor(paquete.estado), 
                                                    '&:hover': { backgroundColor: '#fef3c7', transform: 'scale(1.005)' },
                                                    transition: 'all 0.2s',
                                                    '&:last-child td, &:last-child th': { border: 0 } 
                                                }}
                                            >
                                                <TableCell sx={{ fontSize: '0.875rem', fontWeight: 500, padding: '16px' }}>
                                                    {paquete.torre_nombre}
                                                </TableCell>
                                                <TableCell sx={{ fontSize: '0.875rem', fontWeight: 600, padding: '16px' }}>
                                                    {paquete.num_apartamento}
                                                </TableCell>
                                                <TableCell sx={{ fontSize: '0.875rem', padding: '16px' }}>
                                                    {paquete.nombre} {paquete.apellido}
                                                </TableCell>
                                                <TableCell sx={{ fontSize: '0.875rem', padding: '16px' }}>
                                                    {formatDate(paquete.fecha_recibido)}
                                                </TableCell>
                                                <TableCell sx={{ padding: '16px' }}>
                                                    <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-semibold bg-amber-100 text-amber-800 shadow-sm">
                                                        ⏳ {paquete.estado}
                                                    </span>
                                                </TableCell>
                                                <TableCell sx={{ padding: '16px' }}>
                                                    <Button 
                                                        variant="outlined" 
                                                        size= "small"
                                                        onClick={() => handleInfoPackage(paquete)}
                                                        sx={{
                                                            textTransform: 'none',
                                                            borderRadius: '8px',
                                                            borderColor: '#f59e0b',
                                                            color: '#f59e0b',
                                                            fontWeight: 600,
                                                            '&:hover': {
                                                                backgroundColor: '#fef3c7',
                                                                borderColor: '#d97706',
                                                                transform: 'translateY(-2px)',
                                                                boxShadow: '0 4px 6px rgba(245, 158, 11, 0.25)'
                                                            },
                                                            transition: 'all 0.2s'
                                                        }}
                                                    >
                                                        <PostAddIcon sx={{ fontSize: 18, mr: 0.5 }} />
                                                        Ver
                                                    </Button>
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                            <TablePagination
                                rowsPerPageOptions={[5, 10, 25]}
                                component="div"
                                count={paqueteria.length}
                                rowsPerPage={rowsPerPage}
                                page={page}
                                onPageChange={(event, newPage) => {
                                    setPage(newPage);
                                }}
                                onRowsPerPageChange={(event) => {
                                    setRowsPerPage(parseInt(event.target.value, 10));
                                    setPage(0);
                                }}
                                sx={{
                                    borderTop: '2px solid #e2e8f0',
                                    backgroundColor: '#f9fafb'
                                }}
                            />
                        </div>
                    )}
                </div>
            </div>
        </div>

        {/* DIALOGO PARA MOSTRAR INFORMACION DE PAQUETE */}
        <Dialog
                fullScreen={fullScreen}
                fullWidth
                maxWidth="md"
                sx={{ width: { xs: '90%', md: '50%' }, mx: 'auto' }}
                open={openDialog}
                onClose={handleClose}
            >
                <DialogTitle sx={{ textAlign: 'center' }}>
                    <Typography>
                        Estado del paquete: {packageInfo ? packageInfo.estado : 'Cargando...'}
                    </Typography>
                    <Typography>
                        {packageInfo && packageInfo.estado === 'Entregado' && (
                            <>Fecha de entrega: {formatDate(packageInfo.fecha_entrega)}</>
                        )}
                    </Typography>
                </DialogTitle>
                <DialogContent>
                    {packageInfo ? (
                        <>
                            <TableContainer elevation={3} sx={{ p: 2, border: '1px solid #ccc' }}>
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell colSpan={2} sx={{ backgroundColor: '#f5f5f5', textAlign: 'center' }}>Información del paquete:</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        <TableRow>
                                            <TableCell>Nombre</TableCell>
                                            <TableCell>{packageInfo.nombre} {packageInfo.apellido}</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell>Fecha de Recibido</TableCell>
                                            <TableCell>{formatDate(packageInfo.fecha_recibido)}</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell>Estado</TableCell>
                                            <TableCell>{packageInfo.estado}</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell>Observaciones</TableCell>
                                            <TableCell>{packageInfo.observacion}</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell>Remitente</TableCell>
                                            <TableCell>{packageInfo.remitente}</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell>Tipo de Paquete</TableCell>
                                            <TableCell>{packageInfo.tipo_paquete}</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell>Cantidad</TableCell>
                                            <TableCell>{packageInfo.cantidad}</TableCell>
                                        </TableRow>
                                    </TableBody>
                                </Table>
                            </TableContainer>
                            <TableContainer elevation={3} sx={{ p: 2, border: '1px solid #ccc' }}>
                                <Table>
                                    <TableBody>
                                        <TableRow>
                                            <TableCell colSpan={2} sx={{ backgroundColor: '#f5f5f5', textAlign: 'center' }}>Residente</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell>Nombre</TableCell>
                                            <TableCell>{packageInfo.nombre} {packageInfo.apellido}</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell>Teléfono</TableCell>
                                            <TableCell>
                                                {packageInfo.telefono}
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell>Correo</TableCell>
                                            <TableCell>
                                                {packageInfo.email}
                                            </TableCell>
                                        </TableRow>
                                    </TableBody>
                                    <TableBody>
                                        <TableRow>
                                            <TableCell>Torre</TableCell>
                                            <TableCell>{packageInfo.torre_nombre}</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell>Número de Apartamento</TableCell>
                                            <TableCell>{packageInfo.num_apartamento}</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell>Piso</TableCell>
                                            <TableCell>{packageInfo.piso}</TableCell>
                                        </TableRow>
                                    </TableBody>
                                </Table>
                            </TableContainer>
                            {packageInfo && packageInfo.estado !== 'Pendiente' && (
                                <TableContainer elevation={3} sx={{ p: 2, border: '1px solid #ccc' }}>
                                    <Table>
                                        <TableBody>
                                            <TableRow>
                                                <TableCell colSpan={2} sx={{ backgroundColor: '#f5f5f5', textAlign: 'center' }}>Firma de Recibido</TableCell>
                                            </TableRow>
                                            <TableRow>
                                                <TableCell colSpan={2} sx={{ textAlign: 'center' }}>
                                                    {packageInfo.firma_entrega ? (
                                                        <img
                                                            src={`${BASE_URL}/${packageInfo.firma_entrega}`}
                                                            alt="Firma de entrega"
                                                            style={{ maxWidth: '100%', maxHeight: '300px' }}
                                                        />
                                                    ) : (
                                                        <span>No hay firma de entrega disponible</span>
                                                    )}
                                                </TableCell>
                                            </TableRow>
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            )}
                        </>
                    ) : (
                        <Typography>Cargando...</Typography>
                    )}
                </DialogContent>
            </Dialog>
        </>
    );
}

export default PackagesControl;